export interface GetPatrolDaysRequest {
  branchCode: string
  placeCode: string
  year: string
  month: string
}

export function GetPatrolDaysRequestToJSON(value: GetPatrolDaysRequest): any {
  return {
    branch_code: value.branchCode !== '' ? value.branchCode : undefined,
    place_code: value.placeCode !== '' ? value.placeCode : undefined,
    year: value.year !== '' ? value.year : undefined,
    month: value.month !== '' ? value.month : undefined
  }
}
